var _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSupervisoryReview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16717",
    fill: "none",
    stroke: "#1f76b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12598",
    d: "M20.475 14.025a3.5 3.5 0 11-4.95 0 3.5 3.5 0 014.95 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12599",
    d: "M17.9 4l1.671 1.142a2 2 0 01.86 1.434L21.464 16"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12600",
    d: "M8.475 14.025a3.5 3.5 0 11-4.95 0 3.5 3.5 0 014.95 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12601",
    d: "M9.5 16.473A2.44 2.44 0 0112 14.1a2.44 2.44 0 012.5 2.375"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12602",
    d: "M6.1 4L4.426 5.142a2 2 0 00-.859 1.434L2.536 16"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12603",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}

export default SvgSupervisoryReview;


//////////////////
// WEBPACK FOOTER
// ./src/icons/SupervisoryReview.svg
// module id = 854
// module chunks = 101